import React, { useEffect } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

import SignIn from './SignIn';
import DefaultLayout from './Sidebar/DefaultLayout';

import Error404 from '../MainPage/ErrorPage/Error404';
import Error500 from '../MainPage/ErrorPage/Error500';
import { UserProvider } from '../core/context/user';

export default function App() {
  const location = useLocation();

  useEffect(() => {
    if (
      location.pathname.includes('signIn') ||
      location.pathname.includes('signUp') ||
      location.pathname.includes('index-three') ||
      location.pathname.includes('forgetPassword')
    ) {
      document.body.classList.add('account-page');
    }
    return () => {
      document.body.classList.remove('account-page');
    };
  }, [location.pathname]);

  if (location.pathname === '/') {
    return <Redirect to="/main/dashboard" />;
  }

  return (
    <UserProvider>
      <Switch>
      <Route path="/signIn" component={SignIn} />
      {/* <Route path="/forgetPassword" component={ForgetPassword} />
      <Route path="/signUp" component={SignUp} /> */}
      <Route path="/main" component={DefaultLayout} />

      <Route path="/error-404" component={Error404} />
      <Route path="/error-500" component={Error500} />
    </Switch>
    </UserProvider>
  );
}
